import React from "react";

function CautionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.56251 0.0380859C6.68829 0.0380859 6.81407 0.0654297 6.92892 0.117383L12.0777 2.30215C12.6793 2.55645 13.1277 3.1498 13.125 3.86621C13.1113 6.57871 11.9957 11.5416 7.28439 13.7975C6.82775 14.0162 6.29728 14.0162 5.84064 13.7975C1.12931 11.5416 0.0136843 6.57871 1.24373e-05 3.86621C-0.00272194 3.1498 0.445716 2.55645 1.04728 2.30215L6.19884 0.117383C6.31095 0.0654297 6.43673 0.0380859 6.56251 0.0380859ZM6.56251 1.86465V12.2006C10.3359 10.374 11.3504 6.32988 11.375 3.90449L6.56251 1.86465Z"
        fill="#0055A4"
      />
    </svg>
  );
}

export default CautionIcon;
